<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Claim Type Details Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination"
          item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch" group-by="clmType" show-group-by>
          <template slot="items" slot-scope="props">
            <td>{{ appDesc(props.item.appId) }}</td>
            <td>{{ props.item.clmType }}</td>
            <td>{{ props.item.clmSubType }}</td>
            <td>{{ props.item.qryRef }}</td>
            <td>{{ props.item.lvlNo }}</td>
            <td>{{ props.item.onVal }}</td>
            <td>{{ props.item.seqNo }}</td>
            <td>{{ props.item.qryRefDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['claimReview'])" @review="doReview(props.item)" remove @remove="doPromptRemove(props.item)"
                query @query="doQuery(props.item)"/>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Claim Type Details
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="showClmTypeDetDialog" width="800px" v-if="checkAccess(['claimReview'])" persistent>
        <clm-type-det-dialog :selectedClmTypeDet="selectedClmTypeDet" :mode="mode" :clmTypeDets="clmTypeDets" @close="showClmTypeDetDialog = false" @fetchData="fetchData"/>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove" title="Claim Type Detail">
        Are you sure that you want to remove the selected claim type detail? (<b>{{deleteClmTypeDet.qryRef}} - {{deleteClmTypeDet.qryRefDesc}}</b>)
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { appIDDesc } from '@/const/underwriting'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import ClmTypeDetDialog from './ClmTypeDetDialog'
export default {
  data() {
    return {
      loading: false,
      search: '',
      headers: [
        { text: 'Module', align: 'left', value: 'appId' },
        { text: 'Claim Type', align: 'left', value: 'clmType' },
        { text: 'Sub Type', align: 'left', value: 'clmSubType' },
        { text: 'Query Ref', align: 'left', value: 'qryRef' },
        { text: 'Level No', align: 'left', value: 'lvlNo' },
        { text: 'On Value', align: 'left', value: 'onVal' },
        { text: 'Seq No', align: 'left', value: 'seqNo' },
        { text: 'Query Description', align: 'left', value: 'qryRefDesc' },
        TableConst.tableActionHeader
      ],
      selectedClmTypeDet: {
        appId: '',
        clmType: '',
        clmSubType: '',
        qryRef: '',
        qryRefDesc: '',
        seqNo: '',
        isMand: false,
        lvlNo: undefined,
        onVal: '',
        fldForm: '',
        permVal: '',
        fldLookup: '',
        isLossDt: false
      },
      deleteClmTypeDet: {},
      clmTypeDets: [],
      mode: '',
      showClmTypeDetDialog: false,
      promptRemove: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmTypeDets
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = data
            this.clmTypeDets = data
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim type details (Missing API URL)')
      }
      this.loading = false
    },
    doNew() {
      this.selectedClmTypeDet.appId = ''
      this.selectedClmTypeDet.clmType = ''
      this.selectedClmTypeDet.clmSubType = ''
      this.selectedClmTypeDet.qryRef = ''
      this.selectedClmTypeDet.qryRefDesc = ''
      this.selectedClmTypeDet.seqNo = ''
      this.selectedClmTypeDet.isMand = false
      this.selectedClmTypeDet.isLossDt = false
      this.selectedClmTypeDet.lvlNo = 1
      this.selectedClmTypeDet.onVal = ''
      this.selectedClmTypeDet.fldForm = ''
      this.selectedClmTypeDet.permVal = ''
      this.selectedClmTypeDet.fldLookup = ''
      this.mode = 'new'
      this.showClmTypeDetDialog = true
    },
    doQuery(clmTypeDet) {
      this.selectedClmTypeDet.appId = clmTypeDet.appId
      this.selectedClmTypeDet.clmType = clmTypeDet.clmType
      this.selectedClmTypeDet.clmSubType = clmTypeDet.clmSubType
      this.selectedClmTypeDet.qryRef = clmTypeDet.qryRef
      this.selectedClmTypeDet.qryRefDesc = clmTypeDet.qryRefDesc
      this.selectedClmTypeDet.seqNo = clmTypeDet.seqNo
      this.selectedClmTypeDet.isMand = clmTypeDet.isMand
      this.selectedClmTypeDet.isLossDt = clmTypeDet.isLossDt
      this.selectedClmTypeDet.lvlNo = clmTypeDet.lvlNo
      this.selectedClmTypeDet.onVal = clmTypeDet.onVal || '' // blank converted to null on
      this.selectedClmTypeDet.fldForm = clmTypeDet.fldForm
      this.selectedClmTypeDet.permVal = clmTypeDet.permVal || '' // blank converted to null on
      this.selectedClmTypeDet.fldLookup = clmTypeDet.fldLookup || '' // blank converted to null on
      this.mode = 'query'
      this.showClmTypeDetDialog = true
    },
    doReview(clmTypeDet) {
      this.selectedClmTypeDet.appId = clmTypeDet.appId
      this.selectedClmTypeDet.clmType = clmTypeDet.clmType
      this.selectedClmTypeDet.clmSubType = clmTypeDet.clmSubType
      this.selectedClmTypeDet.qryRef = clmTypeDet.qryRef
      this.selectedClmTypeDet.qryRefDesc = clmTypeDet.qryRefDesc
      this.selectedClmTypeDet.seqNo = clmTypeDet.seqNo
      this.selectedClmTypeDet.isMand = clmTypeDet.isMand
      this.selectedClmTypeDet.isLossDt = clmTypeDet.isLossDt
      this.selectedClmTypeDet.lvlNo = clmTypeDet.lvlNo
      this.selectedClmTypeDet.onVal = clmTypeDet.onVal || '' // blank converted to null on
      this.selectedClmTypeDet.fldForm = clmTypeDet.fldForm
      this.selectedClmTypeDet.permVal = clmTypeDet.permVal || '' // blank converted to null on
      this.selectedClmTypeDet.fldLookup = clmTypeDet.fldLookup || '' // blank converted to null on
      this.mode = 'review'
      this.showClmTypeDetDialog = true
    },
    doPromptRemove(clmTypeDet) {
      this.deleteClmTypeDet = clmTypeDet
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.$store.state.claimParam.menu.deleteClmTypeDet
      if (apiURI) {
        this.loading = true
        const params = {
          appId: this.deleteClmTypeDet.appId,
          clmType: this.deleteClmTypeDet.clmType,
          clmSubType: this.deleteClmTypeDet.clmSubType,
          qryRef: this.deleteClmTypeDet.qryRef,
          lvlNo: this.deleteClmTypeDet.lvlNo,
          onVal: this.deleteClmTypeDet.onVal || '',
          seqNo: this.deleteClmTypeDet.seqNo
        }
        try {
          const result = await this.$http.post(apiURI, params)
          this.notify(result.data)
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    appDesc(appID) {
      return appIDDesc[appID]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  components: {
    ClmTypeDetDialog: ClmTypeDetDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
